<template>
    <div class="homeBox">
        <!-- <div class="homeBox1">
            <el-card class="box-card" style="width:16%;margin-right: 3%">
                <div slot="header" class="clearfix" style="text-align: center">
                    <span>今日下单量</span>
                </div>
                <div class="numShow">{{order_count}}</div>
            </el-card>
            <el-card class="box-card" style="width:16%;margin-right: 3%">
                <div slot="header" class="clearfix" style="text-align: center">
                    <span>今日撤销量</span>
                </div>
                <div class="numShow">{{cancel_count}}</div>
            </el-card>
            <el-card class="box-card" style="width:16%;margin-right: 3%">
                <div slot="header" class="clearfix" style="text-align: center">
                    <span>今日投保中</span>
                </div>
                <div class="numShow">{{insuring_count}}</div>
            </el-card>
            <el-card class="box-card" style="width:16%;margin-right: 3%">
                <div slot="header" class="clearfix" style="text-align: center">
                    <span>今日已投保</span>
                </div>
                <div class="numShow">{{insured_count}}</div>
            </el-card>
            <el-card class="box-card" style="width:16%;margin-right: 3%">
                <div slot="header" class="clearfix" style="text-align: center">
                    <span>今日退保/拒保</span>
                </div>
                <div class="numShow">{{reject_count}}</div>
            </el-card>
            <el-card class="box-card" style="width:16%;margin-right: 3%">
                <div slot="header" class="clearfix" style="text-align: center">
                    <span>今日下单收入</span>
                </div>
                <div class="numShow">{{income}}</div>
            </el-card>
            <el-card class="box-card" style="width:16%">
                <div slot="header" class="clearfix" style="text-align: center">
                    <span>今日撤单退款</span>
                </div>
                <div class="numShow">{{expend}}</div>
            </el-card>
        </div>
        <div class="homeBox1">
            <div class="echarts" style="margin-right: 4%" id="myChart1">
                    
            </div>
            <div class="echarts" id="myChart2">
                
            </div>
        </div> -->
    </div>
</template>

<script>
import { homeData } from "@/api/common"

export default {
    name: "home",
    data() {
        return {
            chart_show: false,
            order_count: 0,
            insuring_count: 0,
            insured_count: 0,
            reject_count: 0,
            cancel_count: 0,
            income: 0,
            expend: 0,
        };
    },
    mounted(){
    },
    methods: {
        getHomeData(){
            homeData().then(res=>{
                if(res.code ==1){
                    
                }
            })
        }
    }
};
</script>
<style lang="less">
    @media (max-width: 991px) {
        .home {
            width: 1024px;
        }
    }
    .homeBox1 {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
    }
    .numShow {
        width: 100%;
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-size: 32px;
        color: #67C23A;
    }
    .echarts{
        width: 48%;
        height: 400px;
        margin: 30px 0;
    }
</style>
